export default "__VITE_ASSET__ni$OwtVH__"